
import { Vue, Component, Prop } from "vue-property-decorator";
import { QuestionV2 } from "@/lib/model/exambuilder/question-v2";
import AudioStyle from "@/components/videoPaly/audioStyle.vue";
import Template from "@/views/ai-builder/components/template.vue";
import { Table } from "element-ui";
import scoped from "@vue/component-compiler-utils/lib/stylePlugins/scoped";
@Component({
  methods: { scoped },
  components: { Template, AudioStyle, Table }
})
export default class QuestionDetail extends Vue {
  // 使用sync传值自动修改
  @Prop({ type: Boolean, default: false }) show!: boolean;
  @Prop({ type: String, default: "" }) title?: string;
  @Prop({
    type: QuestionV2,
    default: () => {
      return new QuestionV2();
    }
  })
  question!: QuestionV2; //题目model
  @Prop({ type: Boolean, default: true }) showAllDimension?: boolean;
  get visible() {
    return this.show;
  }
  set visible(value) {
    this.$emit("update:show", value);
  }
  get dimension() {
    return this.question.firstFilterDimension;
  }
  get noBottomInfo() {
    // 没有备注且是选择题
    return !this.question.remark && this.question.isSingleSelect();
  }
  closeDetail(done: any) {
    this.$emit("update:show", false);
    // done();
  }
  getCellStyle({ rowIndex, columnIndex }: any) {
    // { padding: '0' }
    if (
      rowIndex == this.question.blankQuestionConfig.answerList.length - 1 &&
      columnIndex === 2
    ) {
      return { padding: "0", borderBottomRightRadius: "8px" };
    } else {
      return { padding: "0" };
    }
  }
}
